module.exports = __webpack_public_path__ + "img/handle-curved.3b70c153.svg";